module.exports = function() {
    $('.universal-promo-card-share-icon-wrapper').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).toggleClass('is-active');
        
        return false;
    });

    $('.universal-promo-card-share-icon-wrapper').hover(function() {
        $(this).addClass('is-active');
    }, function() {
        $(this).removeClass('is-active');
    });
};